import React, { useState, useEffect } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import VideoBackground from './components/VideoBackground';
import Hero from './components/Hero';
import AboutSection from './components/AboutSection';
import NewCollection from './components/NewCollection';
import BannerSection from './components/BannerSection';
import NewArrivals from './components/NewArrivals';
import ComboPromo from './components/ComboPromo';
import ShopPage from './components/ShopPage';
import AboutUsPage from './components/AboutUsPage';
import Footer from './components/Footer';
import SplashScreen from './components/SplashScreen';

function App() {
  const [scrollY, setScrollY] = useState(0);
  const [currentView, setCurrentView] = useState('home');
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    // Scroll to top on page load/reload
    window.scrollTo(0, 0);
    
    // Hide splash screen after 2.5 seconds
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 2500);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1);
      if (hash === 'shop') {
        setCurrentView('shop');
      } else if (hash === 'about') {
        setCurrentView('about');
      } else {
        setCurrentView('home');
      }
    };

    window.addEventListener('hashchange', handleHashChange);
    handleHashChange();

    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
    setCurrentView('shop');
    window.location.hash = 'shop';
    window.scrollTo(0, 0);
  };

  return (
    <div className="App">
      <SplashScreen isVisible={showSplash} />
      
      <Navbar onCategorySelect={handleCategorySelect} />
      
      {currentView === 'home' ? (
        <>
          <VideoBackground scrollY={scrollY} />
          <Hero scrollY={scrollY} />
          <AboutSection />
          <NewCollection onCategorySelect={handleCategorySelect} />
          <ComboPromo onCategorySelect={handleCategorySelect} />
          <BannerSection />
          <NewArrivals onCategorySelect={handleCategorySelect} />
        </>
      ) : currentView === 'about' ? (
        <AboutUsPage />
      ) : (
        <ShopPage preselectedCategory={selectedCategory} />
      )}
      
      <Footer />
    </div>
  );
}

export default App;
